import { Component, EventEmitter, Host, HostBinding, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { GradeOverrideLegendComponent } from '../../shared-components/controls/grade-override-legend/grade-override-legend.component';
import { TabsComponent } from '../../shared-components/controls/tabs/tabs.component';
import { GradeOverrideCode } from '../../shared-components/models/grade-override-code.model';
import { SchoolYearSettings } from '../../shared-components/year/school-year-settings.model';
import { LoginService } from '../../shared-modules/login/login.service';
import { AssignmentFilterParam } from './assignment-filter-param';
import { AssignmentFilterComponent } from './assignment-filter/assignment-filter.component';
import { AssignmentService } from './assignment.service';
import { ByCourseComponent } from './by-course/by-course.component';
import { UpcomingMissingComponent } from './upcoming-missing/upcoming-missing.component';

@Component({
    selector: 'app-assignment',
    templateUrl: './assignment.component.html',
    styleUrls: ['./assignment.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class AssignmentComponent implements OnInit, OnDestroy {
    @HostBinding('class.sis-app-root') sisAppRoot: Host = true;

    tabNames: string[] = ['By Course', 'Upcoming/Missing'];
    selectedTab: string;
    toggleAllRows: EventEmitter<boolean> = new EventEmitter<boolean>();
    ShowByClass: boolean;
    subscriptions: Subscription[] = [];
    showFilter = false;
    overrideLegendDialog: MatDialogRef<GradeOverrideLegendComponent>;
    schoolYearSettings: SchoolYearSettings;

    // ------------Element references--------------------------------
    @ViewChild('byCourse', { static: true }) byCourse: ByCourseComponent;
    @ViewChild('upcomingMissing', { static: true }) upcomingMissing: UpcomingMissingComponent;
    @ViewChild('assignmentFilter', { static: true }) assignmentFilter: AssignmentFilterComponent;
    @ViewChild(TabsComponent, { static: true }) tabComponent: TabsComponent;

    // ------------------ filter -------------------------
    isFiltered: boolean;
    filterParam = new AssignmentFilterParam();

    constructor(
        private dialog: MatDialog,
        private assignmentService: AssignmentService,
        private loginService: LoginService
    ) {
    }

    ngOnInit() {
        this.assignmentService.filterParam = this.filterParam;
        this.tabChange('By Course');
        this.subscriptions.push(
            this.toggleAllRows.subscribe(toggle => {
                if (this.ShowByClass) {
                    this.byCourse.expandAll(toggle);
                } else {
                    this.upcomingMissing.expandAll(toggle);
                }
            })
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        });
    }

    getSelectedTabIndex() {
        return this.tabNames.indexOf(this.selectedTab);
    }

    schoolYearSettingsChange(schoolYearSettings: SchoolYearSettings) {
        this.schoolYearSettings = schoolYearSettings;
    }

    tabChange(tab) {
        this.selectedTab = tab;
        this.ShowByClass = tab === 'By Course';
        this.assignmentService.ShowByClass = this.ShowByClass;
        if (this.ShowByClass) {
            this.byCourse.loadFilterParam();
        }
        else {
            this.upcomingMissing.loadFilterParam();
        }
        this.assignmentFilter.loadCourseAndTerms();
        this.assignmentFilter.filterParam = this.assignmentService.filterParam;
        this.isFiltered = this.assignmentService.filterParam.isFilterApplied();
    }

    missingRetrieved() {
        if (this.assignmentService.filterbyCard == false) {
            this.tabChange('Upcoming/Missing');
            this.tabComponent.clickTabWithoutEvents('Upcoming/Missing');
        }
    }

    filterChange() {
        this.isFiltered = this.assignmentService.filterParam.isFilterApplied();
        this.assignmentService.filterChange.emit();
    }

    showFilterClick() {
        this.showFilter = !this.showFilter;
    }

    clearFilterClick() {
        this.assignmentFilter.clearFilter();
    }

    showLegends() {
        return this.ShowByClass && this.byCourse && this.byCourse.selectedCourse && this.byCourse.studentAssignments.filter(x => x.SpecialMark !== '').length > 0;
    }

    legendClick() {
        const overrideCodes: GradeOverrideCode[] = [];
        this.byCourse.studentAssignments.forEach(function (element) {
            if ((element.SpecialMark !== '') && ((overrideCodes.map(function (e) { return e.Code; }).indexOf(element.SpecialMark) == -1))) {
                overrideCodes.push({
                    'Id': 0,
                    'Code': element.SpecialMark,
                    'Description': element.SpecialMarkDescription,
                    'AssignmentCalcOptions': '',
                    'GradePos': 0,
                    'ForGradeReporting': false,
                    'ForAssignments': false,
                    'SetSubsequentGPGrades': false,
                    'ExcludeFromCalculation': false,
                    'SetToZero': false,
                    'GradePoints': 0,
                    'Inc_GPACalc': false
                });
            }
        });

        this.overrideLegendDialog = this.dialog.open(GradeOverrideLegendComponent, { panelClass: 'tyl-mat-dialog', disableClose: true });
        this.overrideLegendDialog.componentInstance.overrideCodes = overrideCodes;
    }
}
